import styled from 'styled-components';

const VideoRequestByWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default VideoRequestByWrapper;
